/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_SourceInputs */

const en_vc_status_source = /** @type {(inputs: Vc_Status_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Figures are the project's own self-assessment from October 2026, measured against public Illustrator documentation. See`)
};

const zh_vc_status_source = /** @type {(inputs: Vc_Status_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以上数据是项目在 2026 年 10 月对照 Illustrator 公开文档所做的自我评估。详见`)
};

/**
* | output |
* | --- |
* | "Figures are the project's own self-assessment from October 2026, measured against public Illustrator documentation. See" |
*
* @param {Vc_Status_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_source = /** @type {((inputs?: Vc_Status_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_source(inputs)
	return zh_vc_status_source(inputs)
});
export { vc_status_source as "vc.status.source" }